const CN_ERROR_CODES = {
  NO_PRACTITIONER: 6
};

export const ALERT_ACTIONS = {
  [CN_ERROR_CODES?.NO_PRACTITIONER]: {
    text: 'Assign Provider',
    icon: 'edit-2-mono',
    color: 'danger',
    size: 'xs',
    onClick: ({ appointmentId }) => {
      if (!appointmentId) return;
      window.open(`/portal?appointment_id=${appointmentId}`);
    }
  }
};
